import { Card, Flex, HStack, Text } from '@talos/kyoko';
import { PreTradeKBInfoTooltip } from '../../../components/PreTradeKBInfoTooltip';
import type { PreTradeResponseData } from '../../../redux/preTradeApi';

import { TotalCostRiskBreakdownTable } from './TotalCostRiskBreakdownTable';
import { TotalCostRiskDonutChart } from './TotalCostRiskDonutChart';
import { useTotalCostRisk } from './useTotalCostRisk';

const COST_RISK_DESCRIPTION =
  'Total cost does not constitute a guarantee or an exact representation of actual execution costs, which may vary due to market conditions, liquidity, and other factors.';

function TotalCostRiskTitle() {
  return (
    <HStack gap="spacing4" alignItems="center">
      Total Cost &amp; Risk
      <PreTradeKBInfoTooltip title="Cost & Risk" description={COST_RISK_DESCRIPTION} />
    </HStack>
  );
}

interface TotalCostRiskProps {
  scenario?: PreTradeResponseData;
}

export function TotalCostRisk({ scenario }: TotalCostRiskProps) {
  const { data } = useTotalCostRisk(scenario);

  if (!data) {
    return (
      <Card title={<TotalCostRiskTitle />} data-testid="total-cost-risk-card">
        <Text color="colorTextSubtle">No cost data available</Text>
      </Card>
    );
  }

  return (
    <Card title={<TotalCostRiskTitle />} data-testid="total-cost-risk-card" p="spacing12">
      <Flex gap="spacing24">
        <Flex flex={1} flexDirection="column">
          <TotalCostRiskBreakdownTable data={data} />
        </Flex>

        <Flex justifyContent="center" alignItems="center">
          <TotalCostRiskDonutChart data={data} />
        </Flex>
      </Flex>
    </Card>
  );
}
